var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1013,
    height: 682,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "grid_svg__b",
    width: 1208,
    height: 682,
    x: -195,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#727272",
    strokeDasharray: "6 6",
    clipPath: "url(#grid_svg__a)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.882 681.353V.089M955.322 681.353V.089M913.762 681.353V.089M872.203 681.353V.089M830.644 681.353V.089M789.075 681.353V.089M747.516 681.353V.089M705.956 681.353V.089M664.396 681.353V.089M622.833 681.353V.089M581.273 681.353V.089M539.713 681.353V.089M498.149 681.353V.089M456.583 681.353V.089M415.003 681.363V.099M373.442 681.363V.099M331.879 681.363V.099M290.319 681.363V.099M248.758 681.363V.099M207.195 681.363V.099M165.635 681.363V.099M124.069 681.363 124.07.099M82.512 681.363V.099M40.955 681.363V.099M-194.675 651.841H1109.52M-194.675 610.3H1109.52M-194.675 568.759H1109.52M-194.675 527.218l1304.195.001M-194.675 485.678H1109.52M-194.675 444.138H1109.52M-194.675 402.595l1304.195.001M-194.675 361.055H1109.52M-194.675 319.516H1109.52M-194.675 277.974l1304.195.001M-194.675 236.434H1109.52M-194.675 194.895H1109.52M-194.675 153.354l1304.195.001M-194.675 111.813H1109.52M-194.675 70.272H1109.52M-194.675 28.733H1109.52"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#grid_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.379,
    cy: 337.923,
    fill: "url(#grid_svg__c)",
    rx: 521.194,
    ry: 308.698
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "grid_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 399.077 -673.786 0 366.379 337.923)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "grid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-195 0h1208v681.935H-195z"
  })))));
};
export default SvgGrid;